import { SITE_NAME, SITE_URL, SITE_DESC, SITE_KEYWORDS, OG_IMAGE } from "@/config";

interface SeoProps {
  title: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
  ogImage?: string;
  ogType?: string;
  jsonLd?: object | object[];
}

function Seo({
  title,
  description = SITE_DESC,
  keywords = SITE_KEYWORDS,
  canonicalPath = "/",
  ogImage = OG_IMAGE,
  ogType = "website",
  jsonLd,
}: SeoProps) {
  const canonical = `${SITE_URL}${canonicalPath === "/" ? "" : canonicalPath}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow" />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {jsonLd ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      ) : null}
    </>
  );
}

export default Seo;